/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import OpenApiV2 from './open-api-v2';
import OpenApiV3 from './open-api-v3';
import { AsyncApiV2, isSupportedByAsyncAPIV2 } from './async-api-v2';
import { get } from 'lodash';

const handleOpenAPI = (api) => {
  if (api.openapi) {
    return new OpenApiV3(api);
  } else if (api.swagger) {
    return new OpenApiV2(api);
  }
};

const handleAsyncAPI = (api) => {
  if (isSupportedByAsyncAPIV2(api)) {
    return new AsyncApiV2(api);
  } else {
    return new AsyncApiV2(api);
  }
};

export default function ApiFactory(api) {
  if (api) {
    if (api.openapi || api.swagger) {
      return handleOpenAPI(api);
    } else if (get(api, '_json.asyncapi')) {
      return handleAsyncAPI(api);
    }
  }

  // Default to Open API version 2.0
  return new OpenApiV2(api);
}
